import type { RppgDemographics } from 'services/rppg/api';
import { UserAttributes } from '../../types';
import {
  formatAge,
  getHeightInCm,
  getWeightInKg,
} from 'lib/utils';

export function mapUserAttributesToRppgDemographics(
  attributes: UserAttributes | null,
): RppgDemographics {
  if (!attributes) {
    return {};
  }

  const ageRaw =
    attributes.birthdate != null ? formatAge(attributes.birthdate) : undefined;
  const age =
    ageRaw != null && ageRaw !== 'N/A' ? Number(ageRaw) : undefined;
  const height =
    attributes.height && attributes.height_unit
      ? getHeightInCm(attributes.height, attributes.height_unit)
      : undefined;
  const weight =
    attributes.weight && attributes.weight_unit
      ? getWeightInKg(attributes.weight, attributes.weight_unit)
      : undefined;

  return {
    ...(age != null && !Number.isNaN(age) ? { age } : {}),
    ...(attributes.gender ? { gender: attributes.gender } : {}),
    ...(height != null && !Number.isNaN(height) ? { height_cm: height } : {}),
    ...(weight != null && !Number.isNaN(weight) ? { weight_kg: weight } : {}),
  };
}
